<template>
  <div id="PropertyContainer">
    <el-dialog v-dialogDrag :title="propertyObj.isFolder === 1 ? '属性' : '版本管理'" :visible.sync="dialogVisible"
      :before-close="handleClose" width="50%" height="40%" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="table-header">
        <el-table :data="basePropertyArr" border height="100%" style="min-height:500px">
          <el-table-column v-if="propertyObj.isFolder !== 1" prop="version" label="版本号" align="center" width="80px" />
          <el-table-column show-overflow-tooltip label="文件名称" prop="name" min-width="120px" align="center">
            <template slot-scope="{ row }">
              <div style="display: flex; align-items: center">
                <fileLightFlag :row="row" @updateLight="updateLight" />
                <span>{{ row.name }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="propertyObj.isFolder === 0" align="center" prop="readableFileSize" label="文件大小" />
          <el-table-column align="center" prop="userName" label="修改人" min-width="120px" />
          <el-table-column show-overflow-tooltip align="center" prop="operDate" label="修改时间" />
          <el-table-column v-if="propertyObj.isFolder !== 1" align="center" prop="remark" label="备注" />
          <el-table-column v-if="!isArchive" label="操作" width="120px" align="center" show-overflow-tooltip>
            <template #default="{ row }">
              <span v-if="propertyObj.isFolder === 0" style="cursor: pointer;color:var(--theme-color);margin-right:10px"
                @click="jump(row)">预览</span>
              <span v-if="downShow" style="cursor: pointer;color:var(--theme-color)" @click="downloadFile(row)">下载</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { LabelFilePreview } from "@/CommonDP/utils/docPublic";
import { downloadFileShowPrompt } from "@/CommonDP/utils";
import docService from "@/CommonDP/service/doc-service";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import fileLightFlag from "@/CommonDP/components/fileLightFlag";
export default {
  props: {isArchive: {
    default: false
  }},
  components: { fileLightFlag },
  data() {
    return {
      basePropertyArr: [],
      LinkDocArr: [],
      argument: {
        folderId: 0,
        prjId: "",
        isRead: 1,
        priviAll: "1"
      },
      dialogVisible: false,
      downDesign: checkPermission(this.$allPerms.XTDESIGN_DOWN),
      timer: null // 定时器
    };
  },
  computed: {
    ...mapState({
      propertyObj: (state) => state.XtDesign.propertyObj,
      prjInfo: (state) => state.projectMg.prjObj,
      userInfo: (state) => state.user.userInfo
    }),
    // 判断有下载权限
    downShow() {
      return this.downDesign && this.propertyObj.isRead === 2 && this.propertyObj.folderType !== 14;
    }
  },
  async mounted() {
    const { folderId } = this.propertyObj;
    if (folderId) {
      this.dialogVisible = true;
    } else {
      this.dialogVisible = false;
    }
    this.argument.prjId = this.prjInfo.prjId;
    if (this.propertyIsShow) {
      this._initLinkDocArr();
    } else {
      this._initBaseProperty();
    }
  },

  methods: {
    updateLight(row, type) {
      const { prjId } = this.prjInfo;
      row.status = "1";
      const status = row.status;
      let messageType;
      type === 1 ? (messageType = "优先轻量化操作") : (messageType = "重新轻量化操作");
      docService
        .updateLight(prjId, row.fileId, row.version)
        .then((res) => {
          if (res.result === "0") {
            row.status = "1";
            this.$message.success(`${messageType}成功`);
            if (!this.timer) {
              this.timer = setInterval(() => {
                this._initBaseProperty();
              }, 3000);
            }
          } else {
            row.status = status;
            this.$message.warning(`${messageType}失败`);
          }
        })
        .catch(() => {
          row.status = status;
          // this.$message.warning(`${messageType}失败`)
        });
    },
    jump(row) {
      const { isFolder } = row;
      if (isFolder === 1) {
        console.log();
      } else {
        if (isFolder === 1) {
          return;
        } else if (row.isDelete === 1) {
          this.$message.warning("该文件已删除，无法查看");
        } else {
          this.viewFile(row);
        }
      }
    },
    // 下载
    async downloadFile(row) {
      console.log(row);
      const prjId = this.prjInfo.prjId;
      const userInfo = this.userInfo;
      const { userId } = userInfo;
      if (this.propertyObj.isFolder !== 1) {
        const fileId = row.fileId;
        const version = row.version;
        docService.downloadFile(prjId, fileId, version).then((response) => {
          const fileName = row.name;
          downloadFileShowPrompt(fileName, response);
        });
      } else {
        var params = {
          folderId: row.fileId,
          rootDirectory: row.name,
          prjId: prjId,
          enterpriseId: this.enterpriseId,
          userId: userId
        };
        docService.downloadfolder(params).then((response) => {
          const fileName = row.name + ".zip";
          downloadFileShowPrompt(fileName, response);
        });
      }
    },
    async viewFile(row) {
      this.onLineView(row);
    },
    async onLineView(row) {
      const { prjId, prjName } = this.prjInfo;
      LabelFilePreview(row, prjId, prjName, "ct", true);
    },
    async _initBaseProperty() {
      const { folderId, isFolder } = this.propertyObj;
      let versionId = "";
      if (this.isSubmit === 1 && this.versionId) {
        versionId = this.versionId;
      }
      const result = await docService.queryBaseProperty(folderId, isFolder, versionId);
      if (result.result === "0") {
        this.basePropertyArr = result.data;
      }
    },

    async _initLinkDocArr() {
      const fileID = this.propertyObj.folderId;
      const result = await docService.queryLinkDoc({ fileID });
      if (result.result === "0") {
        result.data.forEach((item, index) => {
          item.key = new Date().getTime() + index + Math.random();
          if (item.isRelaFolder === 1) {
            item.hasChildren = true;
          }
        });
        this.LinkDocArr = result.data;
      }
    },
    handleClose() {
      clearInterval(this.timer);
      this.$store.dispatch("XtDesignIsShowProperty", {});
    }
  }
};
</script>
<style lang="scss">
#PropertyContainer {
  .el-dialog__body {
    padding: 20px;
    height: calc(100% - 52px);
  }
}
</style>
<style lang="scss" scoped>
#PropertyContainer {
  .table-header {
    width: 100%;
    height: 100%;
  }
}
</style>
